import React, { useContext } from 'react'
import { useRouter } from 'next/router'

import FilterAccommodationType from 'client/components/FilterAccommodationTypes'
import FilterCategory from 'client/components/FilterCategory'
import FilterFacilities from 'client/components/FilterFacilities'
import FilterPrices from 'client/components/FilterPrices'
import FilterRatings from 'client/components/FilterRatings'
import { type FormValues } from '@s4l/ds'
import { FiltersContext } from '../FiltersContainer/context'
import FilterThemes from 'client/components/FilterThemes'
import { SearchFilters } from '@s4l/uikit'
import { SearchFilters as SearchFiltersModel } from '@s4l/stayforlong/property/SearchFilters'
import { useSelector } from 'react-redux'
import { getDistributionPriceRange } from 'src/effects/Properties/selectors'
import { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'

const Filters = () => {
  const { query } = useRouter()
  const distributionPriceRange = useSelector(getDistributionPriceRange)

  const hasNewFilters = query.ff?.includes('new_filters')
  const hasMealPlans = query.ff?.includes('meal_plans')

  const { filters, setFilters } = useContext(FiltersContext)

  function handleApplyFilters(newFilters: FormValues) {
    setFilters(prev => ({ ...prev, ...newFilters }))
  }

  const filtersModel = SearchFiltersModel.fromLegacyContext(filters)

  const listOfPriceDistributionModel =
    ListOfPriceDistribution.fromLegacyContext(distributionPriceRange)

  if (hasNewFilters) {
    return (
      <SearchFilters
        OnFilterChange={handleApplyFilters}
        defaultFiltersJSON={filtersModel.toJSON()}
        listOfPriceDistributionJSON={listOfPriceDistributionModel.toJSON()}
        showMealPlans={hasMealPlans}
      />
    )
  }

  return (
    <>
      <FilterPrices />
      <FilterCategory />
      <FilterRatings />
      <FilterThemes />
      <FilterAccommodationType />
      <FilterFacilities />
    </>
  )
}

export default Filters
